import { render, staticRenderFns } from "./Componenti.vue?vue&type=template&id=38b53874&scoped=true&"
import script from "./Componenti.vue?vue&type=script&lang=js&"
export * from "./Componenti.vue?vue&type=script&lang=js&"
import style0 from "./Componenti.vue?vue&type=style&index=0&id=38b53874&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b53874",
  null
  
)

export default component.exports